export const financingSources = [
  {
    key: "Very-early stage funding",
    value: "veryEarlyStageFunding",
  },
  {
    key: "Early stage funding",
    value: "earlyStageFunding",
  },
  {
    key: "Growth stage funding",
    value: "growthStageFunding",
  },
  {
    key: "Late stage funding",
    value: "lateStageFunding",
  },
  {
    key: "Post-IPO stage funding",
    value: "postIpoStageFunding",
  },
];

export const otherDatasets = [
  {
    key: "Pitch decks showcase",
    value: "pitchDecksShowcase",
  },
  {
    key: "Active companies",
    value: "activeCompanies",
  },
  {
    key: "Shuttered companies",
    value: "shutteredCompanies",
  },
  {
    key: "Investors' losses",
    value: "investorsLosses",
  },
  {
    key: "Discontinued products",
    value: "discontinuedProducts",
  },
  {
    key: "Products showcase",
    value: "productsShowcase",
  },
  {
    key: "Postmortem analysis",
    value: "postmortemAnalysis",
  },
  {
    key: "Portfolio analysis",
    value: "portfolioAnalysis",
  },
  {
    key: "Competitive landscape",
    value: "competitiveAnalysis",
  },
  {
    key: "Idea validation",
    value: "ideaValidation",
  },
];

export const numbersAtAGlance = [
  {
    key: "Total users",
    value: "totalUsers",
  },
  {
    key: "Total customers",
    value: "totalCustomers",
  },
  {
    key: "Total investors",
    value: "totalInvestors",
  },
  {
    key: "Total companies",
    value: "totalCompanies",
  },
  {
    key: "Total active companies",
    value: "totalActiveCompanies",
  },
  {
    key: "Total inactive companies",
    value: "totalInactiveCompanies",
  },
  {
    key: "Total products",
    value: "totalProducts",
  },
  {
    key: "Total pitch decks",
    value: "totalPitchDecks",
  },
];

export const dataTip = {
  veryEarlyStageFunding:
    "Search for funding with our founder-friendly collection of angel investor, micro venture capital, and other very-early stage funding sources.",
  earlyStageFunding:
    "Search for funding with our founder-friendly collection of accelerator, venture capital, and other early stage funding sources.",
  growthStageFunding:
    "Search for funding with our founder-friendly collection of revenue-based financing, growth venture capital, and other growth stage funding sources.",
  lateStageFunding:
    "Search for funding with our founder-friendly collection of family office, private equity, and other late stage funding sources.",
  postIpoStageFunding:
    "Search for funding with our founder-friendly collection of hedge fund, sovereign wealth fund, and other post-IPO funding sources.",
  pitchDecksShowcase: "",
  activeCompanies:
    "Understand the business offerings in your competitive landscape by browsing through our collection of active companies.",
  shutteredCompanies:
    "Discern meaningful insights from our collection of shuttered companies.",
  investorsLosses:
    "Investigate loss of investments from our collection of failed investments.",
  discontinuedProducts:
    "Discover problem-solving creativity from our collection of inactive products.",
  productsShowcase:
    "Inspire to create value-added offering by browsing through our collection of active products.",
  postmortemAnalysis:
    "Examine the pitfalls and mistakes others had made with our structured frameworks.",
  portfolioAnalysis:
    "Evaluate the performance and relationships of portfolio investments with our portfolio risk analytics powered by data science.",
  competitiveAnalysis:
    "Define your competitive edge by analyzing your markets with our AI-powered competitive analytics.",
  ideaValidation:
    "Refine your conceptual ideas into viable and differentiated product-or-solution offering with our AI-powered idea checker.",
  totalUsers: "",
  totalInvestors: "",
  totalCompanies: "",
  totalActiveCompanies: "",
  totalInactiveCompanies: "",
  totalProducts: "",
  totalPitchDecks: "",
};
